import { ref } from "vue";

export const showClearCacheOption = ref(false);
export const isClearingCache = ref(false);

// Chaves do localStorage preservadas ao "Atualizar Sistema": o botão existe para invalidar
// cache de build obsoleto, não as preferências do usuário. Os filtros do Kanban (período, funil
// e tipo de data) usam o prefixo "crm-negocios-kanban-" e devem sobreviver à limpeza.
const PREFIXOS_PRESERVADOS = ["crm-negocios-kanban-"];

export const clearCache = async () => {
  isClearingCache.value = true;

  try {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));

    sessionStorage.clear();
    Object.keys(localStorage)
      .filter((chave) => !PREFIXOS_PRESERVADOS.some((prefixo) => chave.startsWith(prefixo)))
      .forEach((chave) => localStorage.removeItem(chave));

    showClearCacheOption.value = false;
    isClearingCache.value = false;

    location.reload();
  } catch (error) {
    console.error("Erro ao limpar cache:", error);
    isClearingCache.value = false;
  }
};
